import React from 'react';

const PdfProductsImportModal = ({
  preview, options, setOptions,
  filter, setFilter, search, setSearch,
  isSaving, getFiltered, onSave, onClose
}) => {
  if (!preview) return null;

  const filtered = getFiltered();

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'var(--card-bg)', borderRadius: '8px', width: '95%', maxWidth: '1400px',
        maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden'
      }}>
        {/* Header */}
        <div style={{
          padding: '1rem', borderBottom: '1px solid var(--border)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          background: 'linear-gradient(135deg, var(--info), var(--info))'
        }}>
          <div style={{ color: '#fff' }}>
            <h5 style={{ margin: 0, fontSize: '16px' }}>{'🛒'} Import produktów z PDF</h5>
            <div style={{ fontSize: '12px', opacity: 0.9 }}>
              Plik: {preview.filename} | {preview.stats?.total || 0} produktów | {preview.barcodes_scanned || 0} kodów EAN
              {preview.xml_validated && (
                <span> | XML: {preview.xml_invoice_number || ''} ({preview.stats?.xml_matched || 0} OK, {preview.stats?.xml_mismatched || 0} niezg.)</span>
              )}
            </div>
          </div>
          <button onClick={onClose}
            style={{ background: 'var(--bg-secondary)', color: 'var(--text)',
              fontSize: '20px', cursor: 'pointer', padding: '4px 10px' }}>{'×'}</button>
        </div>

        {/* Barcode count mismatch warning */}
        {(preview.barcodes_scanned || 0) > 0 && (preview.barcodes_scanned || 0) < (preview.stats?.total || 0) && (
          <div style={{
            padding: '0.6rem 1rem', backgroundColor: 'rgba(220,53,69,0.12)',
            borderBottom: '2px solid var(--danger)',
            display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '12px', color: 'var(--danger)', fontWeight: '600'
          }}>
            {'⚠️'} UWAGA: Zeskanowano {preview.barcodes_scanned} kodów EAN dla {preview.stats?.total} pozycji
            — brakuje {(preview.stats?.total || 0) - (preview.barcodes_scanned || 0)} kodu(ów).
            Możliwe przesunięcie przypisania EAN! Sprawdź pozycje bez EAN.
          </div>
        )}

        {/* Stats & Options */}
        <div style={{ padding: '1rem', borderBottom: '1px solid var(--border)', backgroundColor: 'var(--bg)' }}>
          <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', alignItems: 'center', marginBottom: '1rem' }}>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <div style={{ textAlign: 'center', padding: '0.5rem 1rem', backgroundColor: 'var(--success-light)', borderRadius: '4px', cursor: 'pointer', border: filter === 'mapped' ? '2px solid var(--success)' : 'none' }}
                onClick={() => setFilter(filter === 'mapped' ? 'all' : 'mapped')}>
                <div style={{ fontSize: '20px', fontWeight: '700', color: 'var(--success)' }}>{preview.stats?.mapped || 0}</div>
                <div style={{ fontSize: '10px', color: 'var(--success)' }}>{'✅'} Zmapowane</div>
              </div>
              <div style={{ textAlign: 'center', padding: '0.5rem 1rem', backgroundColor: 'var(--warning-light)', borderRadius: '4px', cursor: 'pointer', border: filter === 'new' ? '2px solid var(--warning)' : 'none' }}
                onClick={() => setFilter(filter === 'new' ? 'all' : 'new')}>
                <div style={{ fontSize: '20px', fontWeight: '700', color: 'var(--warning)' }}>{preview.stats?.new || 0}</div>
                <div style={{ fontSize: '10px', color: 'var(--warning)' }}>{'➕'} Nowe</div>
              </div>
              <div style={{ textAlign: 'center', padding: '0.5rem 1rem', backgroundColor: 'var(--info-light)', borderRadius: '4px', cursor: 'pointer', border: filter === 'price_changes' ? '2px solid var(--info)' : 'none' }}
                onClick={() => setFilter(filter === 'price_changes' ? 'all' : 'price_changes')}>
                <div style={{ fontSize: '20px', fontWeight: '700', color: 'var(--info)' }}>{preview.stats?.price_changes || 0}</div>
                <div style={{ fontSize: '10px', color: 'var(--info)' }}>{'💰'} Zmiana ceny</div>
              </div>
              {preview.xml_validated && (
                <div style={{
                  textAlign: 'center', padding: '0.5rem 1rem', borderRadius: '4px',
                  backgroundColor: (preview.stats?.xml_mismatched || 0) > 0 ? 'rgba(220,53,69,0.1)' : 'rgba(40,167,69,0.1)',
                  border: (preview.stats?.xml_mismatched || 0) > 0 ? '2px solid var(--danger)' : '2px solid var(--success)'
                }}>
                  <div style={{
                    fontSize: '20px', fontWeight: '700',
                    color: (preview.stats?.xml_mismatched || 0) > 0 ? 'var(--danger)' : 'var(--success)'
                  }}>
                    {(preview.stats?.xml_mismatched || 0) > 0
                      ? `${preview.stats.xml_mismatched} ❌`
                      : `${preview.stats?.xml_matched || 0} ✅`
                    }
                  </div>
                  <div style={{
                    fontSize: '10px',
                    color: (preview.stats?.xml_mismatched || 0) > 0 ? 'var(--danger)' : 'var(--success)'
                  }}>
                    Walidacja XML
                  </div>
                </div>
              )}
            </div>

            <input
              type="text"
              placeholder={'🔍 Szukaj produktu...'}
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{
                padding: '6px 10px', fontSize: '12px', borderRadius: '6px',
                border: '1px solid var(--border)', minWidth: '250px',
                backgroundColor: 'var(--card-bg)', color: 'var(--text)'
              }}
            />
          </div>

          <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '12px', cursor: 'pointer', padding: '0.5rem', backgroundColor: options.update_names ? 'var(--success-light)' : 'var(--bg)', borderRadius: '4px', border: '1px solid var(--border)' }}>
              <input type="checkbox" checked={options.update_names}
                onChange={e => setOptions(prev => ({ ...prev, update_names: e.target.checked }))} />
              {'📝'} Aktualizuj nazwy produktów
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '12px', cursor: 'pointer', padding: '0.5rem', backgroundColor: options.create_new ? 'var(--success-light)' : 'var(--bg)', borderRadius: '4px', border: '1px solid var(--border)' }}>
              <input type="checkbox" checked={options.create_new}
                onChange={e => setOptions(prev => ({ ...prev, create_new: e.target.checked }))} />
              {'➕'} Twórz nowe produkty
            </label>
          </div>
        </div>

        {/* Product list */}
        <div style={{ flex: 1, overflow: 'auto', padding: '0.5rem' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
            <thead style={{ position: 'sticky', top: 0, backgroundColor: 'var(--bg)', zIndex: 10 }}>
              <tr>
                <th style={{ padding: '0.5rem', textAlign: 'center', borderBottom: '2px solid var(--border)', width: '35px' }}>Lp.</th>
                <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '2px solid var(--border)', width: '50px' }}>Status</th>
                <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '2px solid var(--border)', width: '130px' }}>EAN</th>
                <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '2px solid var(--border)' }}>Nazwa z PDF</th>
                {preview.xml_validated && (
                  <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '2px solid var(--border)' }}>Nazwa z XML</th>
                )}
                <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '2px solid var(--border)' }}>Nazwa w systemie</th>
                <th style={{ padding: '0.5rem', textAlign: 'right', borderBottom: '2px solid var(--border)', width: '70px' }}>Ilość</th>
                <th style={{ padding: '0.5rem', textAlign: 'right', borderBottom: '2px solid var(--border)', width: '100px' }}>Cena netto PDF</th>
                <th style={{ padding: '0.5rem', textAlign: 'right', borderBottom: '2px solid var(--border)', width: '100px' }}>Obecna cena</th>
                <th style={{ padding: '0.5rem', textAlign: 'right', borderBottom: '2px solid var(--border)', width: '55px' }}>VAT</th>
              </tr>
            </thead>
            <tbody>
              {filtered.slice(0, 200).map((p, idx) => {
                const priceDiff = p.is_mapped && p.price_differs;
                const nameDiff = p.is_mapped && p.name_differs;

                return (
                  <tr key={idx} style={{
                    backgroundColor: p.is_mapped
                      ? (priceDiff ? 'var(--info-light)' : (idx % 2 === 0 ? 'var(--card-bg)' : 'var(--bg)'))
                      : 'var(--warning-light)'
                  }}>
                    <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'center', fontSize: '10px', color: 'var(--text-muted)', fontFamily: 'monospace' }}>
                      {p.nr_pozycji || (idx + 1)}
                    </td>
                    <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)' }}>
                      {p.is_mapped ? (priceDiff ? '💰' : '✅') : '➕'}
                    </td>
                    <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', fontFamily: 'monospace', fontSize: '10px' }}>
                      {p.ean || '-'}
                    </td>
                    <td style={{
                      padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)',
                      maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                      fontWeight: nameDiff ? '600' : 'normal'
                    }}>
                      {p.nazwa}
                    </td>
                    {preview.xml_validated && (
                      <td style={{
                        padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)',
                        maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                        color: p.xml_match === 'ok' ? 'var(--success)' : p.xml_match === 'mismatch' ? 'var(--danger)' : 'var(--text-muted)',
                        fontWeight: p.xml_match === 'mismatch' ? '600' : 'normal'
                      }}>
                        {p.xml_match === 'ok' ? '✅ ' : p.xml_match === 'mismatch' ? '❌ ' : ''}
                        {p.xml_nazwa || '-'}
                      </td>
                    )}
                    <td style={{
                      padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)',
                      maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                      color: p.is_mapped ? (nameDiff ? 'var(--danger)' : 'var(--success)') : 'var(--text-muted)',
                      fontStyle: nameDiff ? 'italic' : 'normal'
                    }}>
                      {p.existing_name || (p.is_mapped ? '-' : '(nowy produkt)')}
                    </td>
                    <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>
                      {p.ilosc} {p.jednostka}
                    </td>
                    <td style={{
                      padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'right',
                      fontWeight: '600', color: priceDiff ? 'var(--info)' : 'var(--text)'
                    }}>
                      {(p.cena_netto || 0).toFixed(2)} zł
                    </td>
                    <td style={{
                      padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'right',
                      color: priceDiff ? 'var(--danger)' : 'var(--text-muted)',
                      textDecoration: priceDiff ? 'line-through' : 'none'
                    }}>
                      {p.existing_price != null ? `${p.existing_price.toFixed(2)} zł` : '-'}
                    </td>
                    <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>
                      {p.stawka_vat || 23}%
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {filtered.length > 200 && (
            <div style={{ padding: '1rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '11px' }}>
              ... i {filtered.length - 200} więcej produktów
            </div>
          )}
          {filtered.length === 0 && (
            <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-muted)' }}>
              Brak produktów spełniających kryteria filtrowania
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: '1rem', borderTop: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'var(--bg)' }}>
          <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
            {filter !== 'all' && (
              <span>Filtr: {filter === 'mapped' ? 'zmapowane' : filter === 'new' ? 'nowe' : 'zmiany cen'} | </span>
            )}
            Wyświetlono: {Math.min(filtered.length, 200)} z {filtered.length} produktów
          </div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button onClick={onClose}
              style={{ padding: '6px 12px', fontSize: '12px', border: '1px solid var(--border)',
                backgroundColor: 'var(--card-bg)', color: 'var(--text-secondary)', cursor: 'pointer' }}>
              Anuluj
            </button>
            <button onClick={onSave}
              disabled={isSaving}
              style={{
                padding: '6px 12px', fontSize: '12px',
                backgroundColor: isSaving ? 'var(--border)' : 'var(--primary)',
                color: '#fff', cursor: 'pointer', fontWeight: '600'
              }}>
              {isSaving ? '⏳ Zapisywanie...' : `✅ Zapisz produkty (${preview.stats?.total || 0})`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfProductsImportModal;
